import React, { useEffect } from "react";
import Routing from "Routing";

import { UserProvider } from "modules/contexts/common/userContext";
import { PopupProvider } from "modules/contexts/admin/popupContext";
import { TopLayoutProvider } from "modules/contexts/admin/topLayourContext";
import { SettingProvider } from "modules/contexts/admin/settingContext";
import { ConnectHistoryProvider } from "modules/contexts/admin/connectHistoryContext";
import { BrochureProvider } from "modules/contexts/admin/brochureContext";
import { BidProvider } from "modules/contexts/admin/bidContext";
import { ReferenceRoomProvider } from "modules/contexts/admin/referenceRoomContext";
import { ImformationProvider } from "modules/contexts/admin/informationContext";
import { PressProvider } from "modules/contexts/admin/pressContext";
import { NoticeProvider } from "modules/contexts/admin/noticeContext";
import { FinancialProvider } from "modules/contexts/admin/financialContext";
import { OperationProvider } from "modules/contexts/admin/operationContext";
import { InvestmentProvider } from "modules/contexts/admin/investmentContext";
import { HistoryProvider } from "modules/contexts/admin/historyContext";
import { HomeOperationProvider } from "modules/contexts/homeOperationContext";
import { InvestProvider } from "modules/contexts/investContext";
import { PromotionProvider } from "modules/contexts/promotionContext";
import { RecruitProvider } from "modules/contexts/recruitContext";
import { CompanyProvider } from "modules/contexts/companyContext";
import { MainProvider } from "modules/contexts/mainContext";
// import IdleTimer from "modules/utils/IdleTimer";

import Loading from "components/common/Loading";

//Provider list
// 상위 provider는 contexts아래의 하위 폴더명으로 이루어짐
const HomePageProvider = ({ contexts, children }) =>
  contexts.reduce(
    (prev, context) =>
      React.createElement(context, {
        children: prev,
      }),
    children
  );

const AdminProvider = ({ contexts, children }) =>
  contexts.reduce(
    (prev, context) =>
      React.createElement(context, {
        children: prev,
      }),
    children
  );

const App = () => {

  return (
    <>
      {/* 자동 logout 기능 */}
      {/* <IdleTimer /> */}

      {/* 
        1. contexts의 하위 폴더 구조에 맞게 contexts를 구조화할 것
        2. contexts들은 왼쪽에서 오른쪽 순차적으로 run됨
      */}
      <AdminProvider
        contexts={[
          UserProvider,
          PopupProvider,
          TopLayoutProvider,
          SettingProvider,
          ConnectHistoryProvider,
          BrochureProvider,
          BidProvider,
          ImformationProvider,
          PressProvider,
          NoticeProvider,
          FinancialProvider,
          OperationProvider,
          InvestmentProvider,
          HistoryProvider,
          CompanyProvider,
          ReferenceRoomProvider,
        ]}
      >
        <HomePageProvider
          contexts={[
            HomeOperationProvider,
            InvestProvider,
            PromotionProvider,
            RecruitProvider,
            MainProvider,
          ]}
        >
          <Loading />
          <Routing />
        </HomePageProvider>
      </AdminProvider>
    </>
  );
};

export default App;
